module.exports = __webpack_public_path__ + "img/15.18fd61fc.jpg";